export default function Loader() {
  return (
    <div className="global-loader">
      <div className="spinner" />
    </div>
  );
}
